import type { BaseApiResponse } from '@/interfaces/BaseApi'
import type { PortalMessage } from '@/interfaces/PortalMessage'

import http from '@/http'

const BASE_ENDPOINT = '/api/v2/messages'

export const fetchMessages = () => http.get<BaseApiResponse<PortalMessage[]>>(BASE_ENDPOINT)
